<div
  id="sidenav-menu"
  class="sidenav-menu un"
  [class.sidenav-small-icons]="menuState === SidenavMenuStates.SMALL_ICONS"
  [class.sidenav-large-icons]="menuState === SidenavMenuStates.LARGE_ICONS"
  [class.mobile-standard]="menuState === SidenavMenuStates.STANDARD && isMobile() || selectedPortal"
  [class.themed]="isDDorCollections()"
  >
  <div class="accordion-container">
    <div class="scroll-container __scroll">
      <div [hidden]="selectedPortal">
        <mat-accordion class="sidenav-content" [class.nonstandard-view]="menuState !== SidenavMenuStates.STANDARD">
          @for (menu of menuItems; track menu.id) {
            <ng-container *ngTemplateOutlet="menuTemplate; context: {$implicit: menu}"></ng-container>
          }
        </mat-accordion>
      </div>
      @if (selectedPortal) {
        <ng-template [cdkPortalOutlet]="selectedPortal.templatePortal"></ng-template>
      }
    </div>
    @if (resetButton && !selectedPortal) {
      <button [title]="getResetButtonText()" (click)="clickResetButton()"
              class="reset-button"
              [class.small]="menuState === SidenavMenuStates.SMALL_ICONS"
              [attr.accesskey]="resetButton.accessKey || null"
              [attr.aria-keyshortcuts]="resetButton.accessKey ? 'Alt+' + resetButton.accessKey : null">
        @if (menuState === SidenavMenuStates.STANDARD) {
          {{getResetButtonText()}}
        } @else {
          <fa-icon [icon]="['far', 'arrows-rotate']"></fa-icon>
        }
      </button>
    }
  </div>
  @if (!selectedPortal) {
    <div class="sidenav-footer">
      <button (click)="openHelpLink()" aria-label="Go to Follett Software homepage">
        @if (isDDorCollections()) {
          <mat-icon
            class="follett-logo"
            [svgIcon]="this.menuState === SidenavMenuStates.STANDARD ? Icons.NEW_FOLLETT_LOGO_WHITE : Icons.NEW_FOLLETT_LOGO_WHITE_SMALL"
            aria-label="Copy To Clipboard"
            >
          </mat-icon>
        }
        @if (!isDDorCollections()) {
          <mat-icon
            class="follett-logo"
            [svgIcon]="this.menuState === SidenavMenuStates.STANDARD ? Icons.NEW_FOLLETT_LOGO : Icons.NEW_FOLLETT_LOGO_SMALL"
            aria-label="Copy To Clipboard"
            >
          </mat-icon>
        }
      </button>
    </div>
  }
</div>

<!--the template for the list of menu items-->
<ng-template #menuTemplate let-menu>
  @if (menu.subMenuItems?.length > 0 && menuState === SidenavMenuStates.STANDARD) {
    <mat-expansion-panel
      class="nested-menu-container"
      [hideToggle]="menuState !== SidenavMenuStates.STANDARD"
      [disabled]="menuState !== SidenavMenuStates.STANDARD"
      [expanded]="isExpanded(menu.id)"
      >
      <mat-expansion-panel-header
        (click)="addExpanded(menu.id)"
        (keydown.enter)="addExpanded(menu.id)"
        class="nested-menu-container-content"
        [class.menu-item-active]="isHighlighted(menu.id)"
        [collapsedHeight]="'36px'"
        [attr.accesskey]="menu.accessKey || null"
        [attr.aria-keyshortcuts]="menu.accessKey ? 'Alt+' + menu.accessKey : null"
        >
        <div class="nested-menu">
          <ng-container *ngTemplateOutlet="menuBtn"></ng-container>
        </div>
      </mat-expansion-panel-header>
      <mat-accordion class="nested-accordion">
        @for (menu of menu.subMenuItems; track menu.id) {
          <ng-container *ngTemplateOutlet="menuTemplate; context: {$implicit: menu}"></ng-container>
        }
      </mat-accordion>
    </mat-expansion-panel>
  } @else {
    <button
      id="menu-{{menu.id}}"
      [attr.accesskey]="menu.accessKey || null"
      [attr.aria-keyshortcuts]="menu.accessKey ? 'Alt+' + menu.accessKey : null"
      class="menu-list-item"
      (click)="menu.subMenuItems && menu.subMenuItems.length > 0 ? matMenuTrigger.openMenu() : clickButton(menu.id)"
      [class.menu-item-active]="isHighlighted(menu.id)"
      [disabled]="menu.disabled"
      [class.standard-list-item]="menuState === SidenavMenuStates.STANDARD"
      [ngClass]="{'disabled': menu.disabled }"
      >
      <div
        class="side-menu-btn"
        [matMenuTriggerRestoreFocus]="false"
        #matMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu.subMenuItems && menu.subMenuItems.length > 0 ? getMatMenu(menu.id) : null"
        (menuClosed)="focusTrigger(menu.id)"
        >
      </div>
      <ng-container *ngTemplateOutlet="menuBtn"></ng-container>
    </button>
    @if (menu.subMenuItems && menu.subMenuItems.length > 0) {
      <fss-portal-menu-component
        #matMenus
        [menu]="menu"
        [menuState]="menuState"
        (selectedEmit)="clickButton($event)"
        >
      </fss-portal-menu-component>
    }
  }

  <!--the template for each individual menu item-->

  <!--the template for the text inside each individual menu item-->
  <ng-template #menuBtn>
    <div
      class="menu-item-content"
      [class.large-icons]="menuState === SidenavMenuStates.LARGE_ICONS"
      [class.small-icons]="menuState === SidenavMenuStates.SMALL_ICONS"
      >
      <fa-icon
        [class.big-icons]="menuState === SidenavMenuStates.LARGE_ICONS"
        [icon]="iconService.getFaIcon(menu.icon)"
        title="{{menu.name}}"
      ></fa-icon>
      @if (menuState === SidenavMenuStates.STANDARD || menuState === SidenavMenuStates.LARGE_ICONS) {
        <span class="menu-item-name">{{menu.name}}</span>
      }
      @if (menu.count > 0 || menuState === SidenavMenuStates.LARGE_ICONS && childHasCount(menu.id)) {
        <span class="menu-count">
          {{menu.count > 9 ? '9+' : menu.count}}
        </span>
      }
    </div>
  </ng-template>
</ng-template>
